<template>
  <v-text-field
    outlined
    flat
    append-icon="mdi-magnify"
    v-model="inputModel"
    hide-details
    :placeholder="$t('placeholder.search')"
  ></v-text-field>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    const { value } = this;
    return {
      inputModel: value || '',
    }
  },
  watch: {
    inputModel(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('input', newValue);
      }
    },
    value(newValue) {
      this.inputModel = newValue;
    }
  },
}
</script>a